globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.CalendlyIframe = (function(){

  CalendlyIframe.selector = '.calendly-inline-widget';

  CalendlyIframe.init = function($html) {
    $html.find(CalendlyIframe.selector).each(function() {
      var $selector = $(this);
      utils.require([assets.calendly], function() {
        new CalendlyIframe($selector);
      });
    })
  }

  function CalendlyIframe($html) {
    this.$html     = $html;
    this.defaults  = { parentElement: this.$html[0] }
    this.$settings = $.extend({}, this.defaults, $html.data("settings"));
    this.init();
  }

  CalendlyIframe.prototype = {
    init: function() {
      var _this = this;
      Calendly.initInlineWidget(_this.$settings);
      _this.windowEvents();
    },
    windowEvents: function() {
      var _this = this;

      window.addEventListener('message', function(e) {
        var event = e.data.event;
        if (!event || !event.indexOf('calendly') === 0) return;

        switch(event) {
          case "calendly.profile_page_viewed":
            _this.$html.trigger("calendly_profile_page_viewed");
            break;
          case "calendly.event_type_viewed":
            _this.$html.trigger("calendly_event_type_viewed");
            break;
          case "calendly.date_and_time_selected":
            _this.$html.trigger("calendly_date_and_time_selected");
            break;
          case "calendly.event_scheduled":
            _this.$html.trigger("calendly_event_scheduled");
            break;
        }
      });
    },
  }

  return CalendlyIframe;

})();
